import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { EstablishmentLeadData } from "../../types/establishmentLead.type";

interface UseDeleteEstablishmentLeadMaintenanceSpecificationProps {
  establishmentLeadId: string;
  maintenanceSpecification: EstablishmentLeadData['maintenance_specifications'][number];
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useDeleteEstablishmentLeadMaintenanceSpecification = ({
  establishmentLeadId,
  maintenanceSpecification,
  onSuccess,
  onError,
}: UseDeleteEstablishmentLeadMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentLeadMaintenanceSpecification'],
    mutationFn: () => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            id: maintenanceSpecification.id,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}/update_maintenance_models`, {
        lead: payload,
      });
    },
    onSuccess,
    onError,
  })
}
